(function() {
    'use strict';
    
a3_cabin_reports.controller('MessageModalCtrl', MessageModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name MessageModalCtrl
    * @description 
    *  Manages the message Modal
    * @ngInject
    */
function MessageModalCtrl($scope, message, $uibModalInstance, $sce) {
        
        $scope.message = message;
        $scope.cancel = cancel;

        $scope.messageBody = $sce.trustAsHtml(message.Body);
    
        /**
         * Close the modal
         * @memberof MemoModalCtrl
         */
		function cancel() {
			$uibModalInstance.close('close');
		}
	}


})();